import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Invest = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    country: '',
    date: '',
    timeSlot: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const timeSlots = ['9 am – 11 am', '11 am – 1 pm', '1 pm – 3 pm', '3 pm – 5 pm', '5 pm – 6 pm'];

  return (
    <div className="min-h-screen bg-black text-white pt-24">
      <div className="max-w-5xl mx-auto px-6 py-16">
        {/* Hero */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h1 className="text-6xl md:text-8xl font-black mb-8 tracking-tight">
            <span className="text-white">INVEST</span> IN THE FUTURE WITH NEUFORA AI
          </h1>
          <p className="text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
            Empowering smart investments through human-like intelligence.
          </p>
        </motion.div>

        {/* Why Invest */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mb-20"
        >
          <h2 className="text-4xl font-bold mb-8">Why Invest in Neufora</h2>
          <ul className="space-y-4 text-white/70 text-lg leading-relaxed">
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span>Pioneering breakthroughs in AI and robotics with proven research credentials</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span>Scalable technology solutions addressing multi-billion dollar markets</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span>Experienced leadership team with deep expertise in artificial intelligence</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span>Strategic partnerships and collaborations with leading technology institutions</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 mt-1">•</span>
              <span>Clear roadmap for commercial deployment and revenue generation</span>
            </li>
          </ul>
        </motion.section>

        {/* Pull Quote */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mb-20 text-center py-12 border-y border-white/20"
        >
          <p className="text-2xl md:text-3xl italic text-white/90 max-w-3xl mx-auto leading-relaxed">
            "Invest in Neufora — where artificial intelligence reflects the brilliance of the human mind."
          </p>
        </motion.div>

        {/* Investment Meeting Form */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="max-w-2xl mx-auto"
        >
          <h2 className="text-3xl font-bold mb-8 text-center">Request Investment Meeting</h2>
          
          <form
            action="https://formsubmit.co/contact.neufora+v2@gmail.com"
            method="POST"
            className="space-y-6"
          >
             <input
  type="hidden"
  name="_next"
  value="http://neufora.com/thank-you"
/>

            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_subject" value="Investment Meeting Request" />
            
            <div>
              <label htmlFor="fullName" className="block text-sm font-medium text-white/80 mb-2">
                Full Name
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                required
                value={formData.fullName}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/40 focus:border-white/30 focus:outline-none transition-colors"
                placeholder="Your full name"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-white/80 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/40 focus:border-white/30 focus:outline-none transition-colors"
                  placeholder="your@email.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-white/80 mb-2">
                  Phone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/40 focus:border-white/30 focus:outline-none transition-colors"
                  placeholder="+1 234 567 8900"
                />
              </div>
            </div>

            <div>
              <label htmlFor="country" className="block text-sm font-medium text-white/80 mb-2">
                Country
              </label>
              <input
                type="text"
                id="country"
                name="country"
                required
                value={formData.country}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/40 focus:border-white/30 focus:outline-none transition-colors"
                placeholder="Your country"
              />
            </div>

            <div>
              <label htmlFor="date" className="block text-sm font-medium text-white/80 mb-2">
                Preferred Date
              </label>
              <input
                type="date"
                id="date"
                name="date"
                required
                min={new Date().toISOString().split('T')[0]}
                value={formData.date}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white focus:border-white/30 focus:outline-none transition-colors"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-white/80 mb-3">
                Time Slot
              </label>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                {timeSlots.map((slot) => (
                  <label
                    key={slot}
                    className={`flex items-center justify-center px-4 py-3 border rounded-xl cursor-pointer transition-all ${
                      formData.timeSlot === slot
                        ? 'bg-white text-black border-white'
                        : 'bg-white/5 border-white/10 hover:border-white/30'
                    }`}
                  >
                    <input
                      type="radio"
                      name="timeSlot"
                      value={slot}
                      required
                      checked={formData.timeSlot === slot}
                      onChange={handleChange}
                      className="sr-only"
                    />
                    <span className="font-medium">{slot}</span>
                  </label>
                ))}
              </div>
            </div>

            <button
              type="submit"
              className="w-full px-8 py-4 bg-white text-black rounded-xl font-semibold hover:scale-[1.02] transition-transform duration-200"
            >
              Request Investment Meeting
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Invest;